import { useCallback, useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Gallery from "@/components/Gallery";
import ReservationSection from "@/components/ReservationSection";
import LookupSection from "@/components/LookupSection";
import Footer from "@/components/Footer";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  const [view, setView] = useState("landing");
  const [adminToken, setAdminToken] = useState(() => localStorage.getItem("tsf_admin_token"));
  const [loginOpen, setLoginOpen] = useState(false);
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -72 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const handleAdminSuccess = useCallback((token) => {
    localStorage.setItem("tsf_admin_token", token);
    setAdminToken(token);
    setLoginOpen(false);
    setView("admin");
    window.scrollTo(0, 0);
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem("tsf_admin_token");
    setAdminToken(null);
    setView("landing");
  }, []);

  if (view === "admin" && adminToken) {
    return (
      <div className="min-h-screen bg-cream font-sans">
        <Toaster position="top-center" richColors />
        <AdminDashboard token={adminToken} onLogout={handleLogout} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream font-sans text-stone-900" data-testid="landing-page">
      <div className="grain-overlay" />
      <Toaster position="top-center" richColors />
      <Navbar onNavigate={scrollTo} onAdmin={() => setLoginOpen(true)} />
      <Hero onReserve={() => scrollTo("reservation")} onConcept={() => scrollTo("galerie")} />
      <Marquee />
      <Gallery />
      <ReservationSection />
      <LookupSection />
      <Footer onAdmin={() => setLoginOpen(true)} />
      {loginOpen && (
        <AdminLogin onClose={() => setLoginOpen(false)} onSuccess={handleAdminSuccess} />
      )}
    </div>
  );
}

export default App;
